import React, { useEffect, createElement } from 'react';
import { Button } from '../components/ui/Button';
import { Accordion } from '../components/ui/Accordion';
import { Footer } from '../components/Footer';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { AlertCircleIcon, XCircleIcon, CheckCircle2Icon, ShieldIcon, ShieldCheckIcon, FileTextIcon, ClockIcon, MessageSquareIcon, LockIcon, CheckIcon, AlertTriangleIcon, UsersIcon, StarIcon, TrendingDownIcon, TrendingUpIcon, CoffeeIcon, ShieldAlertIcon, ArrowRightIcon, PhoneOffIcon } from 'lucide-react';
// Declare fbq function for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
// A wrapper component to apply the scroll reveal effect to sections
function RevealSection({
  children,
  className = '',
  id
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) {
  const ref = useScrollReveal();
  return <section id={id} ref={ref} className={`opacity-0 translate-y-8 transition-all duration-700 ease-out ${className}`} data-id="element-113">
      {children}
    </section>;
}
export function LandingPage() {
  useEffect(() => {
    // Initialize Meta Pixel
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', undefined, undefined, undefined);
    window.fbq('init', '1847425635830345');
    window.fbq('track', 'PageView');
  }, []);
  const handleAddToCart = () => {
    // Fire AddToCart event
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Guía Eliminar Deudas Antiguas',
        content_ids: ['52483978461473'],
        content_type: 'product',
        value: 6.39,
        currency: 'USD'
      });
    }
    // Redirect to Shopify
    window.location.href = 'https://guiasparavivir.com/cart/52483978461473:1';
  };
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <main className="min-h-screen bg-gray-50 font-sans text-gray-900 selection:bg-emerald-200 selection:text-emerald-900" data-id="element-114">
      {/* URGENCY BANNER */}
      <div className="bg-red-600 text-white text-center py-3 px-4 font-bold text-sm md:text-base flex items-center justify-center gap-2 shadow-md relative z-50" data-id="element-115">
        <AlertTriangleIcon className="w-5 h-5 flex-shrink-0 animate-pulse" data-id="element-116" />
        <span data-id="element-117">
          ⚠️ Si te están llamando cobradores por una deuda vieja, NO les pagues
          ni un centavo hasta leer esto
        </span>
      </div>

      {/* HERO SECTION */}
      <section className="bg-blue-900 text-white pt-16 pb-24 px-4 relative overflow-hidden" data-id="element-118">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSIvPjwvc3ZnPg==')] opacity-30" data-id="element-119"></div>
        <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-120">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/20 border border-emerald-400/50 text-emerald-300 text-sm font-bold mb-8 tracking-wide" data-id="element-121">
            <UsersIcon className="w-4 h-4" data-id="element-122" />
            <span data-id="element-123">
              + de 2,300 personas ya eliminaron sus deudas con este método
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-7xl font-extrabold leading-tight mb-6 tracking-tight" data-id="element-124">
            Eliminar Deudas Antiguas en 48 Horas{' '}
            <span className="text-emerald-400 block mt-2" data-id="element-125">
              Sin Pagar un Solo Centavo
            </span>
          </h1>

          <h2 className="text-xl md:text-2xl text-blue-100 font-medium leading-relaxed mb-10 max-w-3xl mx-auto" data-id="element-126">
            El método legal paso a paso para detener el acoso telefónico, anular
            cobros que ya caducaron y recuperar tu paz mental hoy mismo.
          </h2>

          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 md:p-8 text-left mb-12 shadow-2xl max-w-3xl mx-auto" data-id="element-127">
            <p className="text-lg md:text-xl leading-relaxed text-white" data-id="element-128">
              <strong className="text-emerald-300 font-bold text-xl" data-id="element-129">
                Son las 8:00 de la noche.
              </strong>{' '}
              Estás intentando cenar cuando tu teléfono vibra. Una voz agresiva
              te amenaza con demandas por una deuda de hace 10 años. Ese frío en
              el estómago no es miedo, es la señal de que intentan intimidarte
              con una "Deuda Zombi".
            </p>
            <p className="text-lg md:text-xl leading-relaxed text-white mt-4 font-medium" data-id="element-130">
              La mayoría entra en pánico y comete el error más grave: prometer
              un pago pequeño. Al hacerlo, acaban de "resucitar" legalmente una
              deuda que ya estaba muerta.
            </p>
          </div>

          <div className="relative inline-block" data-id="element-131">
            <div className="absolute inset-0 bg-emerald-500 rounded-xl blur-lg opacity-60 animate-pulse" data-id="element-132"></div>
            <Button onClick={scrollToOffer} className="relative text-2xl py-6 px-10" data-id="element-133">
              ELIMINAR MIS DEUDAS AHORA
            </Button>
          </div>

          <div className="flex items-center justify-center gap-6 mt-6 text-blue-200 text-sm font-medium" data-id="element-134">
            <span className="flex items-center gap-1" data-id="element-135">
              <LockIcon className="w-4 h-4" data-id="element-136" /> Pago Seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-137">
              <CheckCircle2Icon className="w-4 h-4" data-id="element-138" /> Acceso Instantáneo
            </span>
          </div>
        </div>
      </section>

      {/* BEFORE / AFTER SECTION */}
      <RevealSection className="py-20 px-4 bg-white" data-id="element-139">
        <div className="max-w-5xl mx-auto" data-id="element-140">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-141">
            La transformación que vivirás en 48 horas
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-142">
            {/* Before */}
            <div className="bg-red-50 rounded-2xl p-8 border border-red-100 shadow-sm" data-id="element-143">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-red-200" data-id="element-144">
                <TrendingDownIcon className="w-8 h-8 text-red-500" data-id="element-145" />
                <h3 className="text-2xl font-bold text-red-900" data-id="element-146">ANTES</h3>
              </div>
              <ul className="space-y-5" data-id="element-147">
                {['Noches sin dormir por las constantes llamadas', 'Miedo y taquicardia cada vez que suena el teléfono', 'Vergüenza cuando llaman a tu trabajo o familiares', 'Ansiedad paralizante por amenazas de embargo', 'Confusión total sobre tus derechos legales'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-148">
                    <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-149" />
                    <span className="text-lg text-red-900/80 font-medium" data-id="element-150">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* After */}
            <div className="bg-emerald-50 rounded-2xl p-8 border border-emerald-100 shadow-sm relative overflow-hidden" data-id="element-151">
              <div className="absolute top-0 right-0 bg-emerald-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-152">
                TU FUTURO
              </div>
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-emerald-200" data-id="element-153">
                <TrendingUpIcon className="w-8 h-8 text-emerald-600" data-id="element-154" />
                <h3 className="text-2xl font-bold text-emerald-900" data-id="element-155">DESPUÉS</h3>
              </div>
              <ul className="space-y-5" data-id="element-156">
                {['Duermes tranquila toda la noche sin interrupciones', 'Contestas el teléfono con total confianza y sin miedo', 'Tu trabajo y tu familia ya no se ven afectados', 'Sabes que NO pueden tocarte legalmente', 'Conoces tus derechos y los haces valer con autoridad'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-157">
                    <CheckCircle2Icon className="w-6 h-6 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-158" />
                    <span className="text-lg text-emerald-900/80 font-medium" data-id="element-159">
                      {text}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-160">
            <Button onClick={scrollToOffer} data-id="element-161">
              QUIERO ESTA TRANQUILIDAD AHORA
            </Button>
          </div>
        </div>
      </RevealSection>

      {/* TESTIMONIALS */}
      <RevealSection className="py-20 px-4 bg-amber-50 border-y border-amber-100" data-id="element-162">
        <div className="max-w-6xl mx-auto" data-id="element-163">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-164">
            Personas reales que ya recuperaron su paz
          </h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-165">
            <div className="bg-white p-8 rounded-2xl shadow-md border border-amber-100/50" data-id="element-166">
              <div className="flex gap-1 mb-4" data-id="element-167">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-168" />)}
              </div>
              <p className="text-lg text-gray-700 italic mb-6 leading-relaxed" data-id="element-169">
                "Llevaba 3 años recibiendo llamadas a las 7am. Envié la carta
                que viene en la guía y en 48 horas... silencio total. No lo
                podía creer. Ojalá hubiera encontrado esto antes."
              </p>
              <div className="font-bold text-gray-900" data-id="element-170">María G.</div>
              <div className="text-gray-500 text-sm" data-id="element-171">58 años, Texas</div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-md border border-amber-100/50" data-id="element-172">
              <div className="flex gap-1 mb-4" data-id="element-173">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-174" />)}
              </div>
              <p className="text-lg text-gray-700 italic mb-6 leading-relaxed" data-id="element-175">
                "Me querían cobrar $4,500 de una tarjeta de hace 12 años.
                Gracias a la guía descubrí que esa deuda ya estaba muerta
                legalmente. No pagué ni un centavo."
              </p>
              <div className="font-bold text-gray-900" data-id="element-176">Roberto L.</div>
              <div className="text-gray-500 text-sm" data-id="element-177">62 años, California</div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-md border border-amber-100/50" data-id="element-178">
              <div className="flex gap-1 mb-4" data-id="element-179">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-180" />)}
              </div>
              <p className="text-lg text-gray-700 italic mb-6 leading-relaxed" data-id="element-181">
                "Mi esposo y yo vivíamos con miedo. Nos amenazaban con quitarnos
                la casa. Todo era mentira. Esta guía nos devolvió la paz y la
                salud mental."
              </p>
              <div className="font-bold text-gray-900" data-id="element-182">Carmen S.</div>
              <div className="text-gray-500 text-sm" data-id="element-183">55 años, Florida</div>
            </div>
          </div>
        </div>
      </RevealSection>

      {/* THE PROBLEM */}
      <RevealSection className="py-20 px-4 bg-white" data-id="element-184">
        <div className="max-w-4xl mx-auto" data-id="element-185">
          <div className="bg-red-100 border-l-4 border-red-600 p-6 md:p-8 rounded-r-2xl mb-12 shadow-sm" data-id="element-186">
            <div className="flex items-start gap-4" data-id="element-187">
              <AlertCircleIcon className="w-8 h-8 text-red-600 flex-shrink-0 mt-1" data-id="element-188" />
              <div data-id="element-189">
                <h3 className="text-2xl font-bold text-red-900 mb-2" data-id="element-190">
                  La Gran Mentira de la Cobranza
                </h3>
                <p className="text-xl text-red-800 font-medium leading-relaxed" data-id="element-191">
                  Las agencias de cobranza ganan{' '}
                  <strong data-id="element-192">$13 MIL MILLONES al año</strong> cobrando deudas que
                  la gente NO tiene obligación legal de pagar.
                </p>
              </div>
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-193">
            Su única estrategia es el terror sicológico
          </h2>

          <div className="prose prose-lg max-w-none text-gray-700" data-id="element-194">
            <p className="text-xl leading-relaxed mb-6" data-id="element-195">
              Compran paquetes de deudas viejas por centavos. Saben
              perfectamente que muchas de esas deudas ya prescribieron
              legalmente y que no pueden llevarte a juicio.
            </p>
            <p className="text-xl leading-relaxed mb-8" data-id="element-196">
              Te llaman al trabajo, acosan a tus familiares y te hacen creer que
              vas a ir a la cárcel o que perderás tu casa. Juegan con tu falta
              de conocimiento legal para obligarte a pagar.
            </p>

            <div className="bg-gray-50 p-8 rounded-2xl border border-gray-200 mt-10" data-id="element-197">
              <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-198">
                Es hora de decir BASTA:
              </h3>
              <ul className="space-y-4 text-xl font-medium text-gray-800" data-id="element-199">
                <li className="flex items-center gap-3" data-id="element-200">
                  <ArrowRightIcon className="w-6 h-6 text-red-500" data-id="element-201" /> ¿Cuántas
                  noches más vas a perder el sueño?
                </li>
                <li className="flex items-center gap-3" data-id="element-202">
                  <ArrowRightIcon className="w-6 h-6 text-red-500" data-id="element-203" /> ¿Cuántas
                  llamadas más vas a aguantar?
                </li>
                <li className="flex items-center gap-3" data-id="element-204">
                  <ArrowRightIcon className="w-6 h-6 text-red-500" data-id="element-205" /> ¿Cuánto
                  dinero más vas a regalar por miedo?
                </li>
              </ul>
            </div>
          </div>
        </div>
      </RevealSection>

      {/* WHY WHAT YOU TRIED DIDN'T WORK */}
      <RevealSection className="py-20 px-4 bg-gray-50 border-y border-gray-200" data-id="element-206">
        <div className="max-w-4xl mx-auto" data-id="element-207">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-10 text-center" data-id="element-208">
            Por qué lo que has intentado no funciona
          </h2>

          <div className="space-y-4 mb-12" data-id="element-209">
            {['Intentaste ignorar las llamadas, pero solo consigues que llamen con más frecuencia y a horas prohibidas.', 'Intentaste razonar con el cobrador, pero ellos están entrenados para ignorar tus explicaciones y seguir presionando.', 'Buscaste información en internet, pero terminaste más confundida con términos legales que no se aplican a tu estado.', 'Pensaste en contratar un abogado, pero el costo de la consulta es más caro que la deuda misma.', 'Les prometiste un pago pequeño para que te dejaran en paz, y lo único que lograste fue reiniciar el reloj legal de la deuda.'].map((item, index) => <div key={index} className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-210">
                <XCircleIcon className="w-7 h-7 text-red-500 flex-shrink-0 mt-0.5" data-id="element-211" />
                <p className="text-lg text-gray-800 font-medium" data-id="element-212">{item}</p>
              </div>)}
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-2xl p-8 text-center shadow-sm" data-id="element-213">
            <h3 className="text-2xl font-bold text-blue-900 mb-3" data-id="element-214">
              No es tu culpa.
            </h3>
            <p className="text-xl text-blue-800" data-id="element-215">
              El sistema está diseñado para que NO sepas tus derechos.{' '}
              <strong className="font-black" data-id="element-216">Hasta ahora.</strong>
            </p>
          </div>
        </div>
      </RevealSection>

      {/* THE UNIQUE MECHANISM */}
      <RevealSection className="py-24 px-4 bg-blue-900 text-white relative" data-id="element-217">
        <div className="max-w-4xl mx-auto text-center" data-id="element-218">
          <div className="inline-flex items-center justify-center gap-2 bg-white text-blue-900 px-6 py-3 rounded-full font-bold text-lg mb-10 shadow-xl" data-id="element-219">
            <ShieldCheckIcon className="w-6 h-6 text-emerald-500" data-id="element-220" />
            Respaldado por la Ley Federal FDCPA
          </div>

          <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-221">
            Presentamos tu nueva arma secreta:{' '}
            <br className="hidden md:block" data-id="element-222" />
            <span className="text-emerald-400" data-id="element-223">
              "Reloj Legal y Escudo Antiacoso"
            </span>
          </h2>

          <p className="text-xl md:text-2xl leading-relaxed text-blue-100 mb-8 max-w-3xl mx-auto font-medium" data-id="element-224">
            Los cobradores SABEN que si tú conoces esta ley, pierden todo su
            poder. Por eso nunca te la mencionan.
          </p>

          <p className="text-xl leading-relaxed text-blue-200 max-w-3xl mx-auto bg-blue-800/50 p-8 rounded-2xl border border-blue-700/50" data-id="element-225">
            Aprenderás a identificar el momento exacto en que una deuda "muere"
            legalmente en tu estado y cómo emitir una Notificación de Cese y
            Desistimiento que obliga a los cobradores a desaparecer de tu vida
            en menos de 48 horas. Una vez que activas el Escudo, ellos saben que
            ya no tienen poder sobre ti.
          </p>
        </div>
      </RevealSection>

      {/* VALUE STACK */}
      <RevealSection className="py-20 px-4 bg-white" data-id="element-226">
        <div className="max-w-4xl mx-auto" data-id="element-227">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center" data-id="element-228">
            Todo lo que necesitas para recuperar tu paz
          </h2>

          <div className="bg-gray-50 rounded-3xl border-2 border-gray-200 overflow-hidden shadow-xl" data-id="element-229">
            <div className="p-8 md:p-10 space-y-6" data-id="element-230">
              <div className="flex items-center justify-between pb-6 border-b border-gray-200" data-id="element-231">
                <div className="flex items-center gap-4" data-id="element-232">
                  <div className="w-12 h-12 bg-blue-100 text-blue-700 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-233">
                    <FileTextIcon className="w-6 h-6" data-id="element-234" />
                  </div>
                  <div data-id="element-235">
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-236">
                      Guía Digital Completa
                    </h3>
                    <p className="text-gray-600" data-id="element-237">El manual paso a paso</p>
                  </div>
                </div>
                <div className="text-right" data-id="element-238">
                  <span className="text-sm text-gray-500 uppercase font-bold" data-id="element-239">
                    Valor
                  </span>
                  <div className="text-2xl font-bold text-gray-400 line-through" data-id="element-240">
                    $47
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between pb-6 border-b border-gray-200" data-id="element-241">
                <div className="flex items-center gap-4" data-id="element-242">
                  <div className="w-12 h-12 bg-emerald-100 text-emerald-700 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-243">
                    <ClockIcon className="w-6 h-6" data-id="element-244" />
                  </div>
                  <div data-id="element-245">
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-246">
                      El Reloj Legal
                    </h3>
                    <p className="text-gray-600" data-id="element-247">
                      Tabla de prescripción (50 estados)
                    </p>
                  </div>
                </div>
                <div className="text-right" data-id="element-248">
                  <span className="text-sm text-gray-500 uppercase font-bold" data-id="element-249">
                    Valor
                  </span>
                  <div className="text-2xl font-bold text-gray-400 line-through" data-id="element-250">
                    $27
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between pb-6 border-b border-gray-200" data-id="element-251">
                <div className="flex items-center gap-4" data-id="element-252">
                  <div className="w-12 h-12 bg-purple-100 text-purple-700 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-253">
                    <CheckCircle2Icon className="w-6 h-6" data-id="element-254" />
                  </div>
                  <div data-id="element-255">
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-256">
                      Hoja de Diagnóstico
                    </h3>
                    <p className="text-gray-600" data-id="element-257">
                      Descubre si tu deuda es "Zombi"
                    </p>
                  </div>
                </div>
                <div className="text-right" data-id="element-258">
                  <span className="text-sm text-gray-500 uppercase font-bold" data-id="element-259">
                    Valor
                  </span>
                  <div className="text-2xl font-bold text-gray-400 line-through" data-id="element-260">
                    $17
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between pb-6 border-b border-gray-200" data-id="element-261">
                <div className="flex items-center gap-4" data-id="element-262">
                  <div className="w-12 h-12 bg-orange-100 text-orange-700 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-263">
                    <MessageSquareIcon className="w-6 h-6" data-id="element-264" />
                  </div>
                  <div data-id="element-265">
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-266">
                      Modelo de Carta Legal
                    </h3>
                    <p className="text-gray-600" data-id="element-267">Lista para copiar y enviar</p>
                  </div>
                </div>
                <div className="text-right" data-id="element-268">
                  <span className="text-sm text-gray-500 uppercase font-bold" data-id="element-269">
                    Valor
                  </span>
                  <div className="text-2xl font-bold text-gray-400 line-through" data-id="element-270">
                    $37
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between pb-6 border-b border-gray-200" data-id="element-271">
                <div className="flex items-center gap-4" data-id="element-272">
                  <div className="w-12 h-12 bg-red-100 text-red-700 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-273">
                    <PhoneOffIcon className="w-6 h-6" data-id="element-274" />
                  </div>
                  <div data-id="element-275">
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-276">
                      Guion del Escudo Antiacoso
                    </h3>
                    <p className="text-gray-600" data-id="element-277">
                      Qué decir exactamente si llaman
                    </p>
                  </div>
                </div>
                <div className="text-right" data-id="element-278">
                  <span className="text-sm text-gray-500 uppercase font-bold" data-id="element-279">
                    Valor
                  </span>
                  <div className="text-2xl font-bold text-gray-400 line-through" data-id="element-280">
                    $27
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-900 text-white p-8 md:p-10 text-center" data-id="element-281">
              <div className="flex justify-center items-center gap-4 mb-4" data-id="element-282">
                <span className="text-xl text-gray-400" data-id="element-283">VALOR TOTAL:</span>
                <span className="text-3xl font-bold text-red-400 line-through decoration-red-500 decoration-4" data-id="element-284">
                  $155
                </span>
              </div>
              <div className="text-4xl md:text-5xl font-extrabold text-emerald-400 mb-8" data-id="element-285">
                Hoy todo por solo $6.39
              </div>
              <div className="relative inline-block w-full md:w-auto" data-id="element-286">
                <div className="absolute inset-0 bg-emerald-500 rounded-xl blur-lg opacity-50 animate-pulse" data-id="element-287"></div>
                <Button onClick={scrollToOffer} className="relative w-full md:w-auto text-2xl py-6 px-12" data-id="element-288">
                  SÍ, QUIERO ELIMINAR MIS DEUDAS
                </Button>
              </div>
            </div>
          </div>
        </div>
      </RevealSection>

      {/* GUARANTEE SECTION */}
      <RevealSection className="py-20 px-4 bg-emerald-600 text-white" data-id="element-289">
        <div className="max-w-4xl mx-auto text-center" data-id="element-290">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-emerald-500 mb-8 shadow-inner border-4 border-emerald-400" data-id="element-291">
            <ShieldCheckIcon className="w-10 h-10 text-white" data-id="element-292" />
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold mb-8" data-id="element-293">
            Nuestra Promesa Blindada
          </h2>
          <p className="text-2xl leading-relaxed font-medium max-w-3xl mx-auto" data-id="element-294">
            Si aplicas el método exactamente como te lo explicamos y los
            cobradores NO dejan de llamarte,{' '}
            <strong className="text-emerald-200" data-id="element-295">
              te devolvemos cada centavo.
            </strong>{' '}
            Sin preguntas, sin complicaciones.
          </p>
          <p className="text-xl mt-6 text-emerald-100" data-id="element-296">
            Todo el riesgo está sobre nuestros hombros. Tú no tienes nada que
            perder, excepto el estrés.
          </p>
        </div>
      </RevealSection>

      {/* WHO THIS IS FOR / NOT FOR */}
      <RevealSection className="py-20 px-4 bg-gray-50 border-t border-gray-200" data-id="element-297">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-298">
          {/* For */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-t-emerald-500" data-id="element-299">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3" data-id="element-300">
              <CheckCircle2Icon className="w-8 h-8 text-emerald-500" data-id="element-301" />
              Para quién es esto
            </h3>
            <ul className="space-y-4" data-id="element-302">
              {['Mujeres y hombres de 50+ que están siendo acosados por deudas de hace más de 5 años.', 'Personas que reciben cartas de agencias de cobranza que no reconocen.', 'Quien quiera limpiar su historial crediticio de cuentas que ya deberían haber desaparecido.', 'Personas que viven en EE.UU. y quieren hacer valer sus derechos federales.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-lg text-gray-700" data-id="element-303">
                  <CheckIcon className="w-6 h-6 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-304" />
                  <span data-id="element-305">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Not For */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-t-red-500" data-id="element-306">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-3" data-id="element-307">
              <XCircleIcon className="w-8 h-8 text-red-500" data-id="element-308" />
              Para quién NO es
            </h3>
            <ul className="space-y-4" data-id="element-309">
              {['Personas con deudas muy recientes (menos de 2 años) que aún están en periodo de demanda activa.', 'Gente que busca "estafar" al sistema con deudas de manutención infantil o impuestos federales recientes.', 'Personas que no están dispuestas a enviar una carta formal por correo.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-lg text-gray-700" data-id="element-310">
                  <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-311" />
                  <span data-id="element-312">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </RevealSection>

      {/* FAQ */}
      <RevealSection className="py-20 px-4 bg-white" data-id="element-313">
        <div className="max-w-3xl mx-auto" data-id="element-314">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center" data-id="element-315">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4" data-id="element-316">
            <Accordion question="¿Es esto legal?" answer="Sí, está basado 100% en las leyes federales de protección al consumidor de EE.UU. (FDCPA)." data-id="element-317" />
            <Accordion question="¿Afectará mi crédito?" answer="Al contrario, aprenderás cómo disputar estas cuentas viejas para que salgan de tu reporte." data-id="element-318" />
            <Accordion question="¿Sirve para cualquier estado?" answer="Sí, cubrimos las variaciones legales de los 50 estados." data-id="element-319" />
            <Accordion question="¿Tengo que hablar con un juez?" answer="No, este método está diseñado para que resuelvas el problema desde tu casa." data-id="element-320" />
            <Accordion question="¿Recibiré algo por correo físico?" answer="No, es un producto digital de acceso inmediato tras el pago." data-id="element-321" />
          </div>
        </div>
      </RevealSection>

      {/* URGENCY & FINAL CTA */}
      <RevealSection id="offer" className="py-24 px-4 bg-gray-50 border-t border-gray-200" data-id="element-322">
        <div className="max-w-3xl mx-auto text-center" data-id="element-323">
          <div className="bg-orange-50 border-2 border-orange-200 rounded-2xl p-6 mb-12 shadow-sm" data-id="element-324">
            <h3 className="text-xl font-bold text-orange-900 mb-2 flex items-center justify-center gap-2" data-id="element-325">
              <ClockIcon className="w-6 h-6" data-id="element-326" /> Oferta de Lanzamiento Limitada
            </h3>
            <p className="text-lg text-orange-800" data-id="element-327">
              Este precio de $6.39 es temporal. Pronto volverá a su precio
              original de $21.30.{' '}
              <strong data-id="element-328">
                Cada día que esperas es un día más de acoso innecesario.
              </strong>
            </p>
          </div>

          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6" data-id="element-329">
            Recupera tu tranquilidad hoy
          </h2>
          <p className="text-2xl text-gray-700 mb-10 font-medium" data-id="element-330">
            Por menos de lo que cuesta un café, pones fin a las noches de
            insomnio.
          </p>

          <div className="bg-white rounded-3xl p-8 md:p-12 border-4 border-emerald-500 shadow-2xl mb-10 relative" data-id="element-331">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-emerald-500 text-white px-6 py-2 rounded-full font-bold text-lg shadow-lg whitespace-nowrap" data-id="element-332">
              ACCESO INMEDIATO
            </div>

            <div className="text-gray-500 font-bold text-xl mb-4 uppercase tracking-wider mt-4" data-id="element-333">
              Inversión Única
            </div>
            <div className="mb-2" data-id="element-334">
              <div className="text-2xl text-gray-400 line-through font-semibold mb-2" data-id="element-335">
                $21.30 USD
              </div>
              <div className="inline-block bg-red-500 text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wide mb-4" data-id="element-336">
                Ahorra 70%
              </div>
            </div>
            <div className="text-7xl font-black text-gray-900 mb-10" data-id="element-337">
              $6.39{' '}
              <span className="text-3xl text-gray-500 font-bold" data-id="element-338">USD</span>
            </div>

            <div className="relative inline-block w-full" data-id="element-339">
              <div className="absolute inset-0 bg-emerald-500 rounded-xl blur-lg opacity-60 animate-pulse" data-id="element-340"></div>
              <Button className="relative w-full py-6 text-2xl md:text-3xl shadow-xl" onClick={handleAddToCart} data-id="element-341">
                ELIMINAR MIS DEUDAS AHORA
              </Button>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-10 text-gray-700 font-bold text-lg" data-id="element-342">
              <span className="flex items-center gap-2" data-id="element-343">
                <LockIcon className="w-6 h-6 text-emerald-600" data-id="element-344" />
                Pago 100% seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-345">
                <ShieldCheckIcon className="w-6 h-6 text-emerald-600" data-id="element-346" />
                Garantía de devolución
              </span>
            </div>
          </div>

          <p className="text-xl text-gray-600 font-medium" data-id="element-347">
            Las personas que actúan HOY reportan resultados en menos de 48
            horas. <br className="hidden md:block" data-id="element-348" />
            Empieza a protegerte en los próximos 5 minutos.
          </p>
        </div>
      </RevealSection>

      <Footer data-id="element-349" />
    </main>;
}